import AnalysysChartsTheme from '@engine/features/analysis_stats/chart/analysis_stats_by_theme.js';
import FetchDataset from '@engine/features/dashboard/chart/dashboard_chart_fetch';
import Top5 from '@engine/features/dashboard/top_5/dashboard_top5_line';

function AnalysisStatsChart($element) {
  var $row = null;
  var entity_type = $element.data('target');
  var entity_id = $element.data('id');
  var container_selector = '.analysis-stats-chart-container';

  var _this = this;

  function chartIsClosed() {
    return $row.find(container_selector).height() === 0;
  }

  _this.renderUI = function () {
    // Create Table Row - update to JSX when introduced
    $row = $('<tr class="analysis-stats-chart">' + '<td colspan="100">' + '<div class="analysis-stats-chart-container">' + '<div class="analysis-stats-chart-alert-container">' + '<div class="dashboard-chart-alert">' + '<div class="alert alert-danger-light">' + '<div class="glyphicon glyphicon-remove-sign"></div>' + ' There was an error trying to get your chart. Please try again later.' + '</div>' + '</div>' + '</div>' + '<div class="dashboard-chart-loader">' + '<div class="spinner blue center"></div>' + '</div>' + '<b><canvas></canvas></b>' + '</div>' + '</td>' + '</tr>'); // Insert the Row in the View

    $row.insertAfter($element.parents('tr')); // Add empty tr to keep the Striped Styles of the table

    $('<tr></tr>').insertAfter($element.parents('tr').next()); // Create the Chart

    Top5.create($row.find('canvas'), AnalysysChartsTheme.styles);
    $element.data('chart', _this.methods);
  };

  _this.openChartUI = function () {
    $row.find(container_selector).addClass('open');
  };

  _this.closeChartUI = function () {
    $row.find(container_selector).removeClass('open');
  };

  _this.toggleChartUI = function () {
    return chartIsClosed() ? _this.openChartUI() : _this.closeChartUI();
  };

  _this.fetchDataset = function () {
    var data = {
      entity: entity_type,
      id: entity_id,
      date_from: $('#from').val(),
      date_to: $('#to').val()
    };
    FetchDataset.fetch('/analysis/highcharts_for', data, function (response) {
      Top5.forceUpdate(response, AnalysysChartsTheme.styles);
      $element.addClass('btn-success-light');
    }, $row.find(container_selector), function () {
      $element.addClass('btn-danger-light');
    });
  };

  _this.methods = {
    render: _this.renderUI,
    fetchDataset: _this.fetchDataset,
    toggle: _this.toggleChartUI,
    close: _this.closeChartUI,
    open: _this.openChartUI
  };
  return _this.methods;
}

export default AnalysisStatsChart;